"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SystemIdentity() {
  const {
    ref: headingRef,
    isVisible: isHeadingVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: separatorRef,
    isVisible: isSeparatorVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: buttonRef,
    isVisible: isButtonVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224011" id="general-pest-defense" className="relative min-h-screen flex flex-col items-center justify-center bg-background overflow-hidden py-24 px-6 sm:px-10">
      {}
      <style>{`
        @keyframes subtle-pulse-scale {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(var(--primary), 0); }
          50% { transform: scale(1.02); box-shadow: 0 0 20px 0 rgba(var(--primary), 0.1); }
        }
        .animate-subtle-pulse {
          animation: subtle-pulse-scale 4s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none flex items-center justify-center">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--foreground)_1px,transparent_1px),linear-gradient(to_bottom,var(--foreground)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.05] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_20%,transparent_100%)]"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col items-center text-center">
        {}
        <div ref={headingRef} className={`transition-all duration-1000 ease-out transform ${isHeadingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default font-bold tracking-tighter leading-[0.95] text-foreground max-w-4xl mx-auto uppercase !text-7xl">Pest Control IN Punta Gorda, FL - $35/Month Protection Plans</h1>
        </div>

        {}
        <div ref={separatorRef} className={`my-12 md:my-16 transition-all duration-1000 delay-300 ease-out h-24 md:h-32 flex items-center justify-center ${isSeparatorVisible ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0"} origin-top`}>
          <Separator orientation="vertical" className="h-full w-[3px] bg-foreground" />
        </div>

        {}
        <div ref={textRef} className={`transition-all duration-1000 delay-500 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-serif text-xl md:text-2xl text-foreground leading-relaxed max-w-3xl mx-auto">Peace River Pest Control provides elite protection for Punta Gorda homes. Our FDACS licensed operators deliver reliable general pest control, <Link to="/TermiteTreatmentPage" className="underline decoration-primary/30 hover:decoration-primary transition-colors">termite treatment</Link>, <Link to="/MosquitoControlPage" className="underline decoration-primary/30 hover:decoration-primary transition-colors">mosquito control</Link>, and spider defense with a focus on local pressures and total transparency.</p>
          
          <p className="font-serif text-lg text-foreground/80 leading-relaxed max-w-3xl mx-auto mt-8">
            Living in <Link to="/PuntaGordaPestControlPage" className="hover:text-primary transition-colors">Punta Gorda</Link> means dealing with a unique subtropical environment where high humidity and proximity to the Peace River create a breeding ground for invasive species. The waterfront lifestyle in <Link to="/PuntaGordaPestControlPage" className="hover:text-primary transition-colors">Punta Gorda</Link> is beautiful, but the moisture-rich air invites subterranean termites and persistent mosquito populations that require specialized local knowledge. Because <Link to="/PuntaGordaPestControlPage" className="hover:text-primary transition-colors">Punta Gorda</Link> experiences warm temperatures year-round, pests never truly go dormant, making consistent, professional barrier treatments essential for every household. Our team understands the specific architectural styles found throughout <Link to="/PuntaGordaPestControlPage" className="hover:text-primary transition-colors">Punta Gorda</Link>, ensuring that every crack and crevice common in Florida construction is properly sealed and treated. We also provide comprehensive <Link to="/PortCharlottePestControlPage" className="hover:text-primary transition-colors">Port Charlotte pest control</Link> for neighboring communities. By choosing a local expert familiar with <Link to="/PuntaGordaPestControlPage" className="hover:text-primary transition-colors">Punta Gorda</Link> pest pressures, you ensure your property remains a sanctuary against the relentless Florida elements. Our specialized <Link to="/CapeCoralPestControlPage" className="hover:text-primary transition-colors">Cape Coral pest control</Link> services extend our reach to ensure regional safety. Protecting your <Link to="/PuntaGordaPestControlPage" className="hover:text-primary transition-colors">Punta Gorda</Link> home isn't just a seasonal task; it is a year-round commitment to health, safety, and structural integrity.
          </p>
        </div>

        {}
        <div ref={buttonRef} className={`mt-16 md:mt-20 transition-all duration-1000 delay-700 ease-out transform ${isButtonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="animate-subtle-pulse inline-block">
            <Button asChild size="lg" className="rounded-full px-10 py-8 text-lg tracking-widest uppercase font-bold shadow-none bg-primary text-primary-foreground hover:scale-105 transition-transform">
              <Link to="/ContactPage">
                Get A Free Quote
                <ArrowDown className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}